export const projectTypeOptions = [
    {
        label: 'GPU marketplace',
        description:
            'Find the cheapest GPUs available in our marketplace. Enjoy $5 in free credits, and easily top up your balance with a credit card.',
        value: 'gpu_marketplace',
    },
    {
        label: 'Your cloud accounts',
        description: 'Connect and manage your cloud accounts. dstack supports all major GPU cloud providers.',
        value: 'own_cloud',
    },
];
